module.exports = __webpack_public_path__ + "static/media/galerija_2016 (14).fc30737a.jpg";